import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import { Container } from 'react-bootstrap';

import messages from '../../locale/messages';
import s from './Contact.css';

// Public "Contact Us" page — the same contact channels (Email / Phone / WhatsApp) surfaced on the
// authenticated /support hub, read from the public site settings. Each channel renders only when its
// setting value exists.
const Contact = (props) => {
  const { intl: { formatMessage }, title, contactEmail, contactPhoneNumber, whatsApp } = props;

  const whatsAppDigits = whatsApp ? String(whatsApp).replace(/[^0-9]/g, '') : '';

  const channels = [
    contactEmail && {
      key: 'email',
      label: formatMessage(messages.emailSupport),
      value: contactEmail,
      href: `mailto:${contactEmail}`,
    },
    contactPhoneNumber && {
      key: 'phone',
      label: formatMessage(messages.callSupport),
      value: contactPhoneNumber,
      href: `tel:${contactPhoneNumber}`,
    },
    whatsAppDigits && {
      key: 'whatsapp',
      label: formatMessage(messages.whatsappSupport),
      value: whatsApp,
      href: `https://wa.me/${whatsAppDigits}`,
      external: true,
    },
  ].filter(Boolean);

  return (
    <div className={cx('subPageContainer')}>
      <Container>
        <div className='subPageWrapper'>
          <p className={s.pageTitle}>{title || formatMessage(messages.contactUs)}</p>
          <p className={s.subText}>{formatMessage(messages.supportIntro)}</p>

          {channels.length > 0 ? (
            <ul className={s.channelList}>
              {channels.map((item) => (
                <li key={item.key} className={s.channelItem}>
                  <a
                    className={s.channelLink}
                    href={item.href}
                    {...(item.external ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
                  >
                    <span className={s.channelInfo}>
                      <span className={s.channelLabel}>{item.label}</span>
                      <span className={s.channelValue}>{item.value}</span>
                    </span>
                    <span className={s.channelArrow} aria-hidden="true">&rsaquo;</span>
                  </a>
                </li>
              ))}
            </ul>
          ) : (
            <p className={s.emptyText}>{formatMessage(messages.supportNoChannels)}</p>
          )}
        </div>
      </Container>
    </div>
  );
};

Contact.propTypes = {
  title: PropTypes.string,
};

export default injectIntl(withStyles(s)(Contact));
